module.exports = __webpack_public_path__ + "static/roll-4b46fac92af423ebe1a2c61531281d0f.gif";